<template>
    <div>
        <skupovi-navigation
                :id="skup_id"
                :breadcrumbs="breadcrumbs"
        >
        </skupovi-navigation>
        <div class="ibox ">
            <div class="ibox-title">
                <h5>Podtema</h5>
            </div>
            <div class="ibox-content">
                <skup-tema2-forma
                        :disabled="false"
                        :id="null"
                        :modal="false"
                        :action="'create'"
                >
                </skup-tema2-forma>
            </div>
        </div>
    </div>
</template>

<script>
import SkupTema2Forma from "@/views/pages/Skupovi/SkupoviTeme2/SkupTema2Forma";
import SkupoviNavigation from "@/views/pages/Skupovi/SkupoviNavigation";
export default {
name: "SkupTema2Create",
    components: {
        SkupTema2Forma,
        SkupoviNavigation
    },
    data(){
        return {
            breadcrumbs: [],
            skup_id: this.$route.params.skup_id,
            skup: {}
        }
    },
    methods:{
        setBreadcrumbs() {
            this.breadcrumbs = [
                {
                    path: '/skupovi/' + this.skup_id + '/podteme',
                    name: 'Podteme'
                },
                {
                    path: '/skupovi/' + this.skup_id + '/podteme/create',
                    name: 'Nova podtema'
                }
            ]
        },

    },
    mounted() {
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>
